import { AppointmentEncounterMode, AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitStatus } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable, TranslatableText } from '@dreryk/react-common';
import { MapMarkerIcon, VideoConsultationIcon } from '@dreryk/react-components';

import { VideoConsultationUrlClipboard } from '~libs.desktop.video-consultation';
import { shouldShowVideoConsultationUrl } from '~libs.shared.appointments-timetable';

import { calendarTranslationKeys } from '../../../../../../translations';

type AppointentEncounterModeInfo = {
   content: TranslatableText;
   description: TranslatableText;
   icon: JSX.Element;
   rightContent?: JSX.Element;
};

type UseAppointmentEncounterModeInfoOptions = {
   appointmentId: number;
   encounterMode: AppointmentEncounterMode;
   appointmentStatus: AppointmentStatus;
   visitStatus?: VisitStatus;
};

export const useAppointmentEncounterModeInfo = (
   options: UseAppointmentEncounterModeInfoOptions
): AppointentEncounterModeInfo => {
   switch (options.encounterMode) {
      case 'ON_SITE':
         return {
            content:
               calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.encounterModeMap.ON_SITE,
            description: calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.encounterMode,
            icon: <MapMarkerIcon />,
         };
      case 'VIDEO_CONSULTATION':
         return {
            content:
               calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.encounterModeMap
                  .VIDEO_CONSULTATION,
            description: calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.encounterMode,
            icon: <VideoConsultationIcon />,
            rightContent: shouldShowVideoConsultationUrl(options.appointmentStatus, options.visitStatus) ? (
               <VideoConsultationUrlClipboard
                  appointmentId={options.appointmentId}
                  label={calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.copyLink}
               />
            ) : undefined,
         };
      default:
         return assertUnreachable(options.encounterMode);
   }
};
